/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_Area_LabelInputs */

const vi_my_grower_report_area_label = /** @type {(inputs: My_Grower_Report_Area_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bãi`)
};

/**

* @param {My_Grower_Report_Area_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_area_label = /** @type {((inputs?: My_Grower_Report_Area_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_Area_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_area_label(inputs)
});